var parameterInsert={ 
    IdDocumentDetails:0,
    ObservationClousure:'', 
    ImgClousure:'', 
    User:'' 
} 
 
 
export default
{
    parameterInsert 
}